import Vue from '@/main.js'
import axios from 'axios'
import state from '@/app/state.js'
import router from '@/router.js'

const instance = axios.create({
  params: {} // do not remove this, its added to add params later in the config
})

instance.defaults.baseURL = process.env.VUE_APP_API

instance.interceptors.request.use((config) => {
  if (!config.headers['Content-Type']) { config.headers['Content-Type'] = 'application/json' }

  Vue.$Progress.start()

  var pathName = window.location.pathname

  // if (!state.getters['auth/isAuthenticated'] && pathName.startsWith('/clientarea')) {
  //   router.push({ name: 'clientareaerror' })
  //   return Promise.reject(new Error('Sistema não authenticado'))
  // }

  if (pathName !== '/login') {
    if (!state.getters['auth/isAuthenticated'] && !pathName.startsWith('/clientarea') && !pathName.startsWith('/atachment/document/pdf')) {
      state.dispatch('auth/authenticationError', 'Sistema não authenticado')

      router.push({ name: 'login' })
      return Promise.reject(new Error('Sistema não authenticado'))
    }

    if (state.getters['auth/isAuthenticated'] && (state.getters['auth/isClient'] && !pathName.startsWith('/clientarea')) && !pathName.startsWith('/atachment/document/pdf')) {
      router.push({ name: 'login' })
      return Promise.reject(new Error('Sistema não authenticado'))
    }

    if (state.getters['auth/isAuthenticated'] && (!state.getters['auth/isClient'] && pathName.startsWith('/clientarea')) && !pathName.startsWith('/atachment/document/pdf')) {
      router.push({ name: 'clientareaerror' })
      return Promise.reject(new Error('Sistema não authenticado'))
    }

    config.headers['Authorization'] = 'Bearer ' + state.getters['auth/accessToken']
    config.headers['departs'] = state.getters['auth/departments']
  }

  return config
}, function (err) {
  return Promise.reject(err)
})

instance.interceptors.response.use((response) => {
  Vue.$Progress.finish()
  return response
}, error => {
  if (error && error.response.status !== 401) {
    Vue.$Progress.fail()
    return Promise.reject(error)
  }
  // Vue.$Progress.fail()
  state.dispatch('auth/authenticationError', 'Autenticação expirou, ou login inválido')
  router.push({ name: 'login' })
})

export default instance
